export default [
  {
    altText: "Become Food Merchant Herobanner",
    bannerID: "Become Food Merchant Herobanner",
    buttonText: "",
    buttonUrl: "",
    desktopImage:
      "https://www.airasia.com/aa/images/web-apps/content-pages/library/AA-Become-Food-Merchant-banner_Dekstop.jpg",
    headline: "",
    mobileImage:
      "https://www.airasia.com/aa/images/web-apps/content-pages/library/AA-Become-Food-Merchant-Mobile.jpg",
    subheadline: "",
    tabletImage:
      "https://www.airasia.com/aa/images/web-apps/content-pages/library/AA-Become-Food-Merchant-banner_Dekstop.jpg",
  }
]
